import { render } from "./LoadingFrame.vue?vue&type=template&id=466f7c66&scoped=true"
import script from "./LoadingFrame.vue?vue&type=script&lang=js"
export * from "./LoadingFrame.vue?vue&type=script&lang=js"

import "./LoadingFrame.vue?vue&type=style&index=0&id=466f7c66&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466f7c66"]])

export default __exports__